import React from "react";
import { SelectOption } from "@showitinc/showit-wc";
import { Map } from "immutable";

import Input from "../app2components/base/Input";
import UIActions from "../actions/UIActions";
import { list as SystemFonts } from "../constants/SystemFonts";
import { MIXED } from "../constants/DesignConstants.mjs";
import AppConstants from "../constants/AppConstants";
import DesignThemeStore from "../stores/DesignThemeStore";
import useStoreState from "./providers/useStoreState";
import { SELECT } from "../constants/InputConstants.mjs";

const { THEME_TAB_FONTS, SELECT_EMPTY_OPTION_TEXT } = AppConstants;

const BROWSER_DEFAULT_OPTIONS = [
  <SelectOption key="default" value="">
    {SELECT_EMPTY_OPTION_TEXT}
  </SelectOption>,
  <SelectOption key="sepDefault" divider />,
];

const NEW_OPTIONS = [
  <SelectOption key="sepNew" divider />,
  <SelectOption key="addNew" value="new">
    Add New
  </SelectOption>,
];

const SYSTEM_FONTS = SystemFonts.map((fontName) => (
  <SelectOption key={`sys${fontName}`} value={fontName}>
    {fontName}
  </SelectOption>
));

const FontSelectInput = ({ allowBrowserDefault = false, fonts, onChange, value, ...other }) => {
  const themeFonts = useStoreState(DesignThemeStore, DesignThemeStore.getFonts);

  const _sortFonts = (fontList) =>
    fontList && fontList.size
      ? fontList
          .sortBy((font) => font.get("name").toLowerCase())
          .reduce((result, font) => {
            const fontName = font.get("name");
            return [
              ...result,
              <SelectOption key={`user${fontName}`} value={fontName}>
                {fontName}
              </SelectOption>,
            ];
          }, Map())
      : [];

  const _getFontList = () => {
    const options = [];

    if (allowBrowserDefault) {
      options.push(...BROWSER_DEFAULT_OPTIONS);
    }

    options.push(..._sortFonts(fonts), ..._sortFonts(themeFonts));

    // Keep an unlisted font visible.
    if (
      value &&
      value !== MIXED &&
      ![...options, ...SYSTEM_FONTS].some((option) => option.props.value === value)
    ) {
      options.push(
        <SelectOption key="missing" value={value}>
          {value}
        </SelectOption>,
      );
    }

    if (options.length) {
      options.push(<SelectOption key="sepSys" divider />);
    }

    options.push(...SYSTEM_FONTS, ...NEW_OPTIONS);

    return options;
  };

  const _handleChange = (e) => {
    const { value } = e?.detail;

    if (value === "new") {
      UIActions.toggleActiveThemeSettingTab({ tabName: THEME_TAB_FONTS });
      UIActions.showTheme();
    } else if (onChange) {
      onChange(e);
    }
  };

  return (
    <Input {...other} value={value} onSISelect={_handleChange} filter inputType={SELECT}>
      {_getFontList()}
    </Input>
  );
};

export default FontSelectInput;
